/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_PriceInputs */

const en_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Price`)
};

const es_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio del anuncio`)
};

const fr_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix de l'annonce`)
};

const de_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat-Preis`)
};

const ja_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格`)
};

const zh_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品价格`)
};

const ar_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سعر الإعلان`)
};

const id_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga Listing`)
};

const it_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo dell'Annuncio`)
};

const ru_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const pt_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço do Anúncio`)
};

const ko_listing_price = /** @type {(inputs: Listing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 가격`)
};

/**
* | output |
* | --- |
* | "Listing Price" |
*
* @param {Listing_PriceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_price = /** @type {((inputs?: Listing_PriceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_PriceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_price(inputs)
	if (locale === "es") return es_listing_price(inputs)
	if (locale === "fr") return fr_listing_price(inputs)
	if (locale === "de") return de_listing_price(inputs)
	if (locale === "ja") return ja_listing_price(inputs)
	if (locale === "zh") return zh_listing_price(inputs)
	if (locale === "ar") return ar_listing_price(inputs)
	if (locale === "id") return id_listing_price(inputs)
	if (locale === "it") return it_listing_price(inputs)
	if (locale === "ru") return ru_listing_price(inputs)
	if (locale === "pt") return pt_listing_price(inputs)
	return ko_listing_price(inputs)
});